
export class Auditoria {
    public IdUsuario;
    public modulo;
    public opcion;
    public accion;
    public mensaje;
    public nrodocumento;
    public tipo; //ADD INE(EGB) 20220614 - REQ22111
    public documento; //ADD INE(EGB) 20220614 - REQ22111
    public IdCliente; //ADD INE(EGB) 20220706 - REQ22111
}
